import {
	checkFlowApproval,
	getUserDeclarationStatus,
	postFlowApproval,
} from '../../services/flowApproval.service';
import { useEffect, useState } from 'react';
import { ApprovalDeclaration } from '../../@types/Declarations.type';
import { DeclarationsOverview } from '../../components/organisms/DeclarationsOverview/DeclarationsOverview';
import { Slider } from './molecules/Slider';
import ApprovalTypeSelector from './molecules/ApprovalTypeSelector';
import { EVENT_TYPES } from '../../shared/constants/events';
import { ANALYTICS_EVENTS } from '../../shared/constants/events';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { sendEvent } from '../../services/user-interaction.service';
import useClarityEvent from '../../hooks/useClarityEvent';
type ApprovalType = 'automatic' | 'manual';

const ApprovalDeclarations = () => {
	const [declarationsPending, setDeclarations] =
		useState<ApprovalDeclaration[]>();
	const [isLoading, setIsLoading] = useState(true);
	const [viewBanner, setViewBanner] = useState(false);
	const [approvalType, setApprovalType] = useState<ApprovalType>('automatic');
	const [isSaving, setIsSaving] = useState(false);
	const { trackEvent } = useClarityEvent();
	const userProfile = useSelector((state: RootState) => state.profile.user);

	const getFlowApproval = async () => {
		try {
			const response = await getUserDeclarationStatus();
			if (response.length > 0) {
				const sortedDeclarations = response.sort(
					(a: ApprovalDeclaration, b: ApprovalDeclaration) => {
						if (a.status === 'pending' && b.status !== 'pending') return -1;
						if (a.status !== 'pending' && b.status === 'pending') return 1;

						const yearDiff = Number(b.detail.year) - Number(a.detail.year);
						if (yearDiff !== 0) return yearDiff;

						return Number(b.detail.month) - Number(a.detail.month);
					},
				);

				setDeclarations(sortedDeclarations);
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	const checkFlow = async () => {
		try {
			const response = await checkFlowApproval();
			if (response?.authorized) {
				setViewBanner(false);
			}
		} catch (error) {}
	};

	const handleSaveDecision = async () => {
		try {
			setIsSaving(true);
			if (approvalType === 'automatic') {
				await postFlowApproval({
					user_id: userProfile?.id,
					authorized: true,
				});
				sendEvent({
					user_id: userProfile?.id,
					event: ANALYTICS_EVENTS.APPROVAL_DECLARATIONS,
					source: 'web',
					event_payload: {
						subsection:
							EVENT_TYPES.APPROVAL_DECLARATIONS_AUTOMATIC_APPROVAL_BY_USER,
						authorized: true,
					},
				});
				trackEvent(EVENT_TYPES.APPROVAL_DECLARATIONS_AUTOMATIC_APPROVAL_BY_USER);
			} else {
				await postFlowApproval({
					user_id: userProfile?.id,
					authorized: false,
				});
				sendEvent({
					user_id: userProfile?.id,
					event: ANALYTICS_EVENTS.APPROVAL_DECLARATIONS,
					source: 'web',
					event_payload: {
						subsection:
							EVENT_TYPES.APPROVAL_DECLARATIONS_MANUAL_APPROVAL_BY_USER,
						authorized: false,
					},
				});
				trackEvent(EVENT_TYPES.APPROVAL_DECLARATIONS_MANUAL_APPROVAL_BY_USER);
			}
			checkFlow();

			setIsSaving(false);
		} catch (error) {
			setIsSaving(false);
		}
	};

	useEffect(() => {
		getFlowApproval();
		checkFlow();
	}, []);

	return (
		<div className='flex flex-col gap-4'>
			{viewBanner && (
				<ApprovalTypeSelector
					approvalType={approvalType}
					onApprovalTypeChange={setApprovalType}
					onSave={handleSaveDecision}
					isSaving={isSaving}
				/>
			)}
			<Slider
				declarationsPending={declarationsPending}
				isLoading={isLoading}
			/>
			<DeclarationsOverview />
		</div>
	);
};

export default ApprovalDeclarations;
